import regExp from './regExp';

class Validator {
  value: string;
  errList: string[];

  constructor(value: string | number | boolean = '') {
    this.value = `${value}`;
    this.errList = [];
  }

  private isIdCardCheckSumOk(idCard: string) {
    if (!regExp.id.test(idCard)) return false;

    const weights = [7, 3, 1, 9, 7, 3, 1, 7, 3];
    const idCardArr = idCard
      .split('')
      .map((item) =>
        Number.isNaN(+item) ? item.toUpperCase().charCodeAt(0) - 55 : +item
      );
    const checkSum = weights
      .map((num: number, i: number) => num * idCardArr[i])
      .reduce((acc, cur) => acc + cur, 0);

    const remainder = checkSum % 10;

    // remainder is 10 exception
    if (remainder === 0) return true;
    return false;
  }

  noValue(msg: string) {
    if (!this.value) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noCheckedValue(msg: string) {
    if (this.value === undefined) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noMinValue(msg: string, min: number) {
    if (+this.value < min) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noMoreThanZero(msg: string) {
    if (Math.sign(+this.value) !== 1) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noLessThanMin(msg: string, min: number) {
    if (+this.value < min) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noMoreThanMax(msg: string, max: number) {
    if (+this.value > max) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  illegalCharEmail(msg: string) {
    if (!regExp.email.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  illegalChar(msg: string) {
    if (!regExp.letter.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidLength(len: number, msg: string, msg2?: string) {
    if (this.value.length < len) {
      this.errList = [...this.errList, msg];
    }
    if (this.value.length > len) {
      this.errList = [...this.errList, msg2 || msg];
    }
    return this;
  }

  noLength(msg: string) {
    if (!this.value || +this.value < 1) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidIdCard(msg: string) {
    if (!this.isIdCardCheckSumOk(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidPassword(msg: string) {
    if (!regExp.password.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  notEqual(val: string, msg: string) {
    if (val !== this.value) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidPostCode(msg: string) {
    if (!regExp.postCode.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidPhone(msg: string) {
    if (!regExp.phone.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  noCheckboxData(msg: string, isRequired: boolean) {
    if (isRequired && this.value === 'false') {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  isEqual(val: string, msg: string) {
    if (val === this.value && !!val) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  invalidHexColor(msg: string) {
    if (!regExp.hexColor.test(this.value)) {
      this.errList = [...this.errList, msg];
    }
    return this;
  }

  res() {
    if (!this.errList.length) {
      return null;
    } else {
      const [firstMsg] = this.errList;
      return firstMsg;
    }
  }
}

export default Validator;
